<template>
  <span v-if="element" :style="inlineStyle">
    <slot />
  </span>
</template>

<script>
export default {
  name: "OmitInline",
  props: ["element"],
  computed: {
    inlineStyle() {
      if (!this.element.omit) {
        return "display:inline;";
      }
      return this.element.omitValue.value ? "display:none;" : "display:inline;";
    }
  }
};
</script>
